import React, { useEffect, useState } from "react";
import "./LoginScreen.css";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store/store";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import GlobalBackground from "../../components/GlobalBackground/GlobalBackground";
import FormInputs from "../../components/FormInputs/FormInputs";
import { authenticateUser, pinpointStatus } from "../../redux/slices/authSlice";
import { loginUser, searchPinPoint } from "../../api/apiServices";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../utils/ToastMessages/ToastMessages";
import { handleCopyPaste } from "../../utils/PreventDefault/PreventDefault";
import CommonLoginToHeader from "../../components/CommonLoginToHeader/CommonLoginToHeader";
import PinPointsContainer from "../../components/PinPointsContainer/PinPointsContainer";
import ForgetPassword from "../../components/ForgetPassword/ForgetPassword";
import { mobileNumber, password, search } from "../../utils/regexData";

const LoginScreen: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [isSearch, setIsSearch] = useState(false);
  const [pinpoint, setPinpoint] = useState<any>({
    username: "",
    email: "",
    name: "",
    addresses: [],
  });
  const [isForgetPass, setIsForgetPass] = useState(false);

  const navigate = useNavigate();
  const {
    register: registerLogin,
    handleSubmit: handleSubmitLogin,
    formState: { errors: errorsLogin },
  }: any = useForm();
  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    formState: { errors: errorsSearch },
  }: any = useForm();

  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    dispatch(pinpointStatus(true));
    sessionStorage.removeItem("unAuthAddress");
  }, []);

  const registerHandler = async (data: any) => {
    try {
      const bodyObject = {
        mobile_number: data.mobile,
        password: data.password,
      };

      const loginResponse: any = await loginUser(bodyObject);
      if (loginResponse?.status) {
        dispatch(authenticateUser(loginResponse?.token));
        dispatch(pinpointStatus(false));
        // const status: any = await checkStatus(
        //   loginResponse?.token,
        //   data.mobile
        // );
        // if (status) {
        showSuccessToast(loginResponse?.message);
        navigate("/home");
        // } else {
        //   navigate("/payment");
        // }
      } else {
        showErrorToast("Login failed!");
      }
    } catch (error: any) {
      navigate("/");
      // console.log("==========>>>>>>", error);
      showErrorToast(error?.response?.data?.error || "Login failed!");
    }
  };

  const searchHandler = async (data: any) => {
    // const newPinPoint = [
    //   {
    //     name: "Amol M Chaphekar",
    //     username: 9860322222,
    //     addresses: {
    //       pinpoint_id: "AS4RFD",
    //       flat_details: "C-204, Rohan Leher,",
    //     area: "Phase 1, Baner",
    //     landmark: "Behind Bitwise Building, Off Mumbai Bangolare Highway",
    //     country: "India",
    //     state: "Maharashtra",
    //     city: "Pune",
    //     pin_code: 411045,
    //     }
    //   },
    // ];
    try {
      const bodyObject = {
        pinpoint_id: data.pinpoint,
      };
      const searchResponse: any = await searchPinPoint(bodyObject);
      if (searchResponse?.status) {
        setPinpoint(searchResponse.data);
        setIsSearch((pre) => true);
      } else {
        // showErrorToast("Failed to search!");
        setIsSearch((pre) => true);
        setPinpoint({ username: "", email: "", name: "", addresses: [] });
      }
    } catch (error: any) {
      navigate("/");
      // console.log("==========>>>>>>", error);
      setIsSearch((pre) => true);
      setPinpoint({ username: "", email: "", name: "", addresses: [] });

      // showErrorToast(error?.response?.data?.error || "Failed to search!");
    }
  };

  const passwordVisibilityHandler = () => {
    setShowPassword(!showPassword);
  };

  const handleForgetPass = () => {
    console.log('------------->>')
    setIsForgetPass(!isForgetPass);
  }

  return (
    <GlobalBackground>
      <div className="login-outer-container">
        {/* <CommonLoginToHeader
          title={"PinPoint Addresses"}
          screen={"login"}
          backScreen={""}
        /> */}
        <div className="image-container">
          <img
            className="login-logo"
            alt="logo"
            src={require("../../assets/images/companyLogo.jpg")}
          />
        </div>
        <form
          className="search-form"
          onSubmit={handleSubmitSearch(searchHandler)}
        >
          <div className="search-container">
            <FormInputs
              maxLength={6}
              type={"default"}
              register={registerSearch}
              placeholder={"Enter PinPoint #"}
              name={"pinpoint"}
              required={"Pinpoint is required"}
              pattern={search}
              message={"Enter a valid pinpoint"}
              errors={""}
              prevent={() => {}}
              disabled={false}
            />

            <div className="login-search-button">
              <button type="submit">Search</button>
            </div>
          </div>
          {errorsSearch?.pinpoint && (
            <p className="search-error">{errorsSearch?.pinpoint.message}</p>
          )}
        </form>

        {pinpoint.addresses.length !== 0 ? (
          <div className="login-pinpoint-container">
            <PinPointsContainer
              pinpoint={pinpoint.addresses}
              userDetails={pinpoint}
            />
          </div>
        ) : (
          <div className="login-empty">
            {isSearch ? <h4>No PinPoints found for your search</h4> : <></>}
          </div>
        )}

        <hr className="login-hr-line-top" />

        <h1 className="login-text">Login</h1>
        <form
          className="login-form"
          onSubmit={handleSubmitLogin(registerHandler)}
        >
          {/* Mobile Input */}
          <FormInputs
            maxLength={10}
            type={"tel"}
            register={registerLogin}
            placeholder={"10 Digit Mobile Number"}
            name={"mobile"}
            required={"Mobile number is required"}
            pattern={mobileNumber}
            message={"Enter a valid 10-digit mobile number"}
            errors={errorsLogin}
            prevent={() => {}}
            disabled={false}
          />

          {/* Password Input */}
          <div className="password-container">
            <FormInputs
              maxLength={15}
              type={showPassword ? "default" : "password"}
              register={registerLogin}
              placeholder={"Password"}
              name={"password"}
              required={"Password is required"}
              pattern={
                password
              }
              message={"Enter a valid password"}
              errors={""}
              prevent={handleCopyPaste}
              disabled={false}
            />
            <div
              onClick={passwordVisibilityHandler}
              className="password-visibility"
            >
              {showPassword ? (
                <img alt="eye" src={require("../../assets/images/eye.png")} />
              ) : (
                <img
                  alt="closed-eye"
                  src={require("../../assets/images/hidden.png")}
                />
              )}
            </div>

            <div className="login-register-button">
              <button type="submit">Login</button>
            </div>
          </div>
          {errorsLogin?.password && (
            <p className="password-error">{errorsLogin?.password.message}</p>
          )}
        </form>

        <div className="forget-pass-container-main">
          <p onClick={handleForgetPass}>Forgot Password</p>
        </div>

        {
          isForgetPass && <ForgetPassword isForgetPass={isForgetPass} setIsForgetPass={setIsForgetPass}/>
        }

        <hr className="login-hr-line" />

        <div className="login-new">
          <h3>or</h3>
          <div
            onClick={() => {
              navigate("/register");
              dispatch(pinpointStatus(true));
            }}
            className="create-new-button"
          >
            <button type="submit">Create New PinPoint</button>
          </div>
          {/* <Link className="login-register" to="/register">
            <h3>Signup Here</h3>
          </Link> */}
          {/* <NavLink  to="/register"><h3>Signup Here</h3></NavLink> */}
        </div>
      </div>
    </GlobalBackground>
  );
};

export default LoginScreen;
